import React from 'react';
import PropTypes from 'prop-types';

import BarRating from '../../library/bar-rating/bar-rating';
import DTGauge from '../../library/gauge/gauge';
import StarBarRating from '../../library/star-bar-rating/star-bar-rating';
import StarRating from '../../library/star-rating/star-rating';

import './review-overview.scss';

function ReviewOverview(props) {
  const {
    averageAnswerRatings,
    className = '',
    numberOfReviews = 0,
    ratingCounts,
    recommendedCount = 0,
    recommendedMessage,
    totalRating
  } = props;

  return (
    <div className={`${className} review-overview`} styleName="container">
      <div
        className={className ? `${className}__overall` : null}
        styleName="overall"
      >
        <div styleName="overall-rating">
          {totalRating && (
            <DTGauge
              draw
              fillPerc={totalRating / 5}
              gaugeHeight={87}
              label="Out Of 5"
              labelPos={{ y: 172 }}
              showBezel={false}
              showTrack
              value={Number(totalRating || 0).toFixed(1)}
              valuePos={{ y: 136 }}
            />
          )}
        </div>
        <div className="recommended">
          {!isNaN(recommendedCount) && numberOfReviews && (
            <>
              <div styleName="recommended-perc">
                <span styleName="recommended-perc-value">
                  {`${Math.round((recommendedCount / numberOfReviews) * 100)}%`}
                </span>
                Recommended
              </div>

              {recommendedMessage && (
                <span styleName="recommended-count">
                  {recommendedCount} of {numberOfReviews} {recommendedMessage}
                </span>
              )}
            </>
          )}

          {totalRating && (
            <div styleName="star-rating">
              <StarRating rating={totalRating} showRating={false} />
              <span styleName="total-review-count">
                {numberOfReviews} Reviews
              </span>
            </div>
          )}
        </div>
      </div>

      <div
        className={className ? `${className}__ratings` : null}
        styleName="ratings"
      >
        {ratingCounts && numberOfReviews && (
          <div styleName="by-review">
            <StarBarRating
              heading="Ratings By Review"
              ratingSummaries={ratingCounts}
              styleName="star-bar-rating-by-review"
              totalCount={numberOfReviews}
            />
          </div>
        )}

        {averageAnswerRatings && (
          <div
            className={
              className ? `${className}__ratings-average-ratings` : null
            }
            styleName="average-ratings"
          >
            <BarRating
              averageRatings={averageAnswerRatings}
              heading="Average Customer Ratings"
            />
          </div>
        )}
      </div>
    </div>
  );
}

ReviewOverview.propTypes = {
  averageAnswerRatings: PropTypes.array,
  className: PropTypes.string,
  numberOfReviews: PropTypes.number,
  ratingCounts: PropTypes.array,
  recommendedCount: PropTypes.number,
  recommendedMessage: PropTypes.string,
  totalRating: PropTypes.number
};

export default ReviewOverview;
